import {ReactComponent as HistoryIcon} from './history.svg'

function History() {
  return <HistoryIcon />
}

export default History
